import React, {useState, useEffect, Component} from 'react';
import dal from '../data/DAL';
import {NavBar, Icon, Toast, ActivityIndicator, WhiteSpace, WingBlank, Flex, Button} from 'antd-mobile';
import FlexItem from 'antd-mobile/lib/flex/FlexItem';
import moment from 'moment'
import Question from "../models/Question";
import {Link} from "react-router-dom";

let debug = require('debug')('APP:QuestionDetail')

const QuestionDetail: React.FC = (props: any) => {
    const [ticketDetailList, setTicketDetailList] = useState(new Array<Question>());
    const [animating, setAnimating] = useState(false);
    const ticket = props.location.state.ticketId;
    const height = document.body.clientHeight;
    let dive: any = null
    useEffect(() => {
        setAnimating(true);
        dal.getTicketDetail(ticket).then(() => {
            setAnimating(false);
            setTicketDetailList(dal.state.ticketDetail);
        })
    }, []);


    const getRef = (e: any) => {
        dive = e;
        scrollToBottom()
    }

    const scrollToBottom = () => {
        if (dive !== null) {
            const scrollHeight = dive.scrollHeight;//里面div的实际高度  2000px
            const height = dive.clientHeight;  //网页可见高度  200px
            const maxScrollTop = scrollHeight - height;
            dive.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }
    }

    return (
        <div>
            <NavBar
                mode="light"
                //icon={<Link to={"/charge-plan"}><Icon color={'#666666'} size={'lg'} type="left"/></Link>}
                icon={<Icon color={'#666666'} size={'lg'} type="left"/>}
                onLeftClick={() => {
                    window.history.back()
                }}
                rightContent={[]}>
                提问记录
            </NavBar>
            <WhiteSpace size="lg"/>
            <Flex style={{flexDirection: 'column'}}>
                <div ref={getRef} style={{height: 610, overflow: 'scroll'}}>
                    <WingBlank>
                        {ticketDetailList.map(r => {
                            return (
                                <FlexItem key={r.id} className={"renew-log-item"}>
                                    <div className="ticketItem">
                                        <div style={{
                                            flex: 1,
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            color: '#ff890a'
                                        }}>
                                            {r.fromUser ? '我: ' : 'Raptor加速回复: '}
                                        </div>
                                        <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end'}}>
                                            {moment(r.createTimeMills).format('YYYY-MM-DD HH:mm:ss')}
                                        </div>
                                    </div>
                                    <br/>
                                    <div style={{marginBottom: '1em', color: 'grey', lineHeight: '20px'}}>
                                        {r.content}
                                    </div>
                                </FlexItem>
                            )
                        })}
                    </WingBlank>
                </div>
            </Flex>
            <p hidden={animating || ticketDetailList.length !== 0} style={{textAlign: 'center'}}>暂无提问记录</p>
            <ActivityIndicator toast text="正在加载" animating={animating}/>
            <div className={'white-item'}/>
            <div className={"sticky-footer"}>
                <div className="card-tile">
                    <div style={{flex: 1}}>
                        <Link className={""} to={{pathname: 'reply-question', state: {ticketId: ticket}}}>
                            <Button type="ghost">回复</Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default QuestionDetail;
